import Api from "../../axios";

export default async function updateEmployeeDetails(data) {
  // console.log("data", data);

  return await Api.post("/update_onboard", data);
}
